import { Component, ViewChild } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Platform, MenuController, IonTabs } from "@ionic/angular";
import { StatusBar, Style } from "@capacitor/status-bar";
import { DownloadsService } from "./services/downloads.service";
import { PushNotificationsService } from "./services/push-notification.service";
import { TimerService } from "./services/timer.service";
import { NavigationModeService } from "./services/navigation-mode.service";
import { NavigationModeResult } from "./capacitor-plugins/navigation-mode";
// import { Deploy } from "cordova-plugin-ionic/dist/ngx";
import { Capacitor } from "@capacitor/core";
import { ToastrService } from "ngx-toastr";
import { Location } from "@angular/common";
import { Preferences } from "@capacitor/preferences";
import { PopoverController } from "@ionic/angular";
import { UpdateNotificationPage } from "./components/update-notification/update-notification.page";
import { SplashScreen } from "@capacitor/splash-screen";
// import { Storage } from "@ionic/storage";

// import { GuidedTourService, Orientation } from "ngx-guided-tour";
import { collection } from "firebase/firestore";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { lastValueFrom } from "rxjs";
import { environment } from "../environments/environment";

@Component({
	selector: "app-root",
	templateUrl: "app.component.html",
	styleUrls: ["app.component.scss"],
})
export class AppComponent {
	@ViewChild("tabs", { static: false }) tabs: IonTabs;
	profile: any = {};
	isLogged = false;
	showDownload = false;
	needsUpdate: any = {};
	checkedUpdate = false;
	updating = true;
	onPdf = false;
	selectedTab;
	progress = 0;
	buffer = 0;
	onExit: any;
	downloadData: any = {};
	version = "V4.9.7";
	idUser = "";
	navMode: NavigationModeResult;

	constructor(
		private platform: Platform,
		private download: DownloadsService,
		private router: Router,
		private menu: MenuController,
		private afAuth: AngularFireAuth,
		private pushService: PushNotificationsService,
		private timerService: TimerService,
		// private localStorage: Storage,
		// private deploy: Deploy, // Comentado - se cargará dinámicamente si es necesario
		private location: Location,
		public toaster: ToastrService,
		// private guidedTourService: GuidedTourService,
		public popoverController: PopoverController,
		public afDb: AngularFirestore,
		private navigationModeService: NavigationModeService
	) {}

	async ngOnInit() {
		this.initializeApp();
		if (Capacitor.getPlatform() !== "web") {
			this.presentPopover();
		}
	}

	async presentPopover() {
		setTimeout(async () => {
			try {
				const snapshotObservable = this.afDb
					.collection("appInformations")
					.doc("version")
					.get();

				const snapshot: any = (await lastValueFrom(snapshotObservable)).data();

				if (environment.version != snapshot.code) {
					const popover = await this.popoverController.create({
						component: UpdateNotificationPage,
						backdropDismiss: false,
						cssClass: "popover-udate",
						translucent: true,
					});
					await popover.present();
					const { role } = await popover.onDidDismiss();
					console.log("onDidDismiss resolved with role", role);
				}
			} catch (err) {
				console.log(err);
			}
		}, 5000);
	}

	initTour() {
		// const data: any = {
		// 	useOrb: false,
		// 	steps: [
		// 		{
		// 			title: "Recorrido",
		// 			selector: ".home-button",
		// 			content:
		// 				"Desde cualquier sección, al hacer clic en este botón regresará a su página de inicio.",
		// 			orientation: Orientation.Bottom,
		// 		},
		// 		{
		// 			title: "Recorrido",
		// 			selector: ".fab-btn-card-I",
		// 			content:
		// 				"No olvide completar todos los datos de su perfil de usuario.",
		// 			orientation: Orientation.Bottom,
		// 		},
		// 		{
		// 			title: "Recorrido",
		// 			selector: ".menu-btn",
		// 			content:
		// 				"Puede editar su página de inicio para que muestre las secciones de su interés.",
		// 			orientation: Orientation.Bottom,
		// 		},

		// 		{
		// 			title: "Recorrido",
		// 			selector: ".tab-publications",
		// 			content: " Sección de Publicaciones Digitales.",
		// 			orientation: Orientation.Top,
		// 		},
		// 		{
		// 			title: "Recorrido",
		// 			selector: ".tab-practice",
		// 			content: "Sección de apoyo a su práctica diaria.",
		// 			orientation: Orientation.Top,
		// 		},
		// 		{
		// 			title: "Recorrido",
		// 			selector: ".tab-old",
		// 			content: " Archivo del Seikyo Criollo.",
		// 			orientation: Orientation.Top,
		// 		},
		// 		{
		// 			title: "Recorrido",
		// 			selector: ".tab-series",
		// 			content: "Noticias y series.",
		// 			orientation: Orientation.Top,
		// 		},
		// 		{
		// 			title: "Recorrido",
		// 			selector: ".tab-media",
		// 			content: "Acceso directo a las redes sociales de la SGIV.",
		// 			orientation: Orientation.Top,
		// 		},
		// 	],
		// };
		// setTimeout(() => {
		// 	this.guidedTourService.startTour(data);
		// 	this.guidedTourService.guidedTourCurrentStepStream.subscribe((step) => {
		// 		if (step == null) {
		// 			Preferences.set({ key: "tourHome", value: "true" });
		// 		}
		// 	});
		// }, 1000);
	}

	setCurrentTab() {
		this.selectedTab = this.tabs.getSelected();
	}
	async initializeApp() {
		setTimeout(() => {
			this.afAuth.onAuthStateChanged(async (user) => {
				if (user) {
					this.isLogged = true;
					const tourHome = await Preferences.get({ key: "tourHome" });
					if (!tourHome.value) {
						this.initTour();
					}
				} else {
					this.isLogged = false;
				}
			});

			this.timerService.init();
			if (Capacitor.getPlatform() !== "web") {
				this.pushService.start();
				this.detectNavigationMode();
			}
		}, 1000);
		if (Capacitor.isNativePlatform()) {
			StatusBar.setStyle({ style: Style.Default });
		}
		setTimeout(async () => {
			await SplashScreen.hide();
		}, 2000);
		this.download.downloads.subscribe((download) => {
			if (this.download.isDownloading) {
				this.showDownload = true;
				this.downloadData = download;
			} else {
				this.showDownload = false;
			}
		});
		this.router.events.subscribe((val) => {
			if (val instanceof NavigationEnd) {
				if (val.url.includes("/pdf/")) {
					this.onPdf = true;
				} else {
					this.onPdf = false;
				}
			}
		});

		this.platform.backButton.subscribe(() => {
			if (this.router.url === "/home") {
				if (this.onExit === true) {
					navigator["app"].exitApp();
				} else {
					this.toaster.info("Salir", "Presiona una vez mas para salir");
					this.onExit = true;
					setTimeout(() => {
						this.onExit = false;
					}, 3000);
				}
			} else {
				this.location.back();
			}
		});
		this.pushService.notificationReceived.subscribe(
			({
				notification: {
					data: { news = "", gosho = "", pdf = "", epub = "", youth = "" } = {},
				} = {},
			}) => {
				if (news) {
					this.router.navigate(["/series", "news", news], { replaceUrl: true });
				} else if (gosho) {
					this.router.navigate(["/series", "goshos", gosho], {
						replaceUrl: true,
					});
				} else if (youth) {
					this.router.navigate(["/series", "youth-journals", youth], {
						replaceUrl: true,
					});
				} else if (pdf) {
					this.router.navigate(["/pdf", pdf]);
				} else if (epub) {
					this.router.navigate(["/epub", epub]);
				}
			}
		);
		// Deploy desactivado temporalmente
		// if (Capacitor.getPlatform() !== "web") {
		// 	try {
		// 		// Cargar Deploy dinámicamente para evitar problemas con JIT compilation
		// 		const { Deploy } = await import("cordova-plugin-ionic/dist/ngx");
		// 		const deploy = new Deploy();
		// 		this.needsUpdate = await deploy.checkForUpdate();
		// 	} catch (error) {
		// 		console.log(error);
		// 		this.checkedUpdate = true;
		// 	}
		// 	if (this.needsUpdate?.available && this.needsUpdate?.compatible) {
		// 		this.menu.open();
		// 		this.updating = true;
		// 		try {
		// 			const { Deploy } = await import("cordova-plugin-ionic/dist/ngx");
		// 			const deploy = new Deploy();
		// 			await deploy.sync(
		// 				{
		// 					updateMethod: "auto",
		// 				},
		// 				(progress) => {
		// 					this.progress = progress / 100;
		// 					this.buffer = progress / 100;
		// 				}
		// 			);
		// 		} catch (error) {
		// 			console.log("Error syncing update:", error);
		// 		}
		// 		this.checkedUpdate = true;
		// 	} else {
		// 		this.checkedUpdate = true;
		// 	}
		// } else {
		// 	this.checkedUpdate = true;
		// }
		this.checkedUpdate = true;
		// this.localStorage.create(); // No necesario con Capacitor Preferences
	}
	async detectNavigationMode() {
		try {
			this.navMode = await this.navigationModeService.detectNavMode();
			console.log("Navigation mode detected:", this.navMode);
		} catch (error) {
			console.error("Error detecting navigation mode:", error);
		}
	}

	close() {
		this.menu.close();
	}
}
